module.exports = __webpack_public_path__ + "static/media/10258.dbe3e719.jpg";